<template>
  <GMapMap
    style="width: 100%; height: 270px; overflow: hidden;"
    :center="center"
    :zoom="6.6"
    :options="{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    }"
  >
    <GMapMarker
      v-for="(location, index) in locations"
      :key="index"
      :options="{ position: location.position }"
      :icon="{
        url: require('@/assets/img/icon_map.png'),
        scaledSize: { width: 25, height: 40 },
      }"
      @click="openMarker(location.id)"
    >
      <GMapInfoWindow
        :closeclick="true"
        @closeclick="openMarker(null)"
        :opened="openedMarkerID === location.id"
      >
        <div>
          <div style="margin-bottom: 10px">
            <b>{{ location.name }}</b>
          </div>
          <ion-button
            size="small"
            class="gtm-appointmentbook-ztk"
            @click="book(location)"
            >Termin buchen</ion-button
          >
          <br />
          <ion-button
            size="small"
            fill="outline"
            :href="'tel:' + location.tel.replace('(0)', '')"
            target="_blank"
            class="gtm-call-ztk"
            v-if="location.tel"
            >{{
              location.tel.replace("+49(0)", "0").replaceAll("-", " ")
            }}</ion-button
          >
          <br />
          <ion-button
            size="small"
            fill="outline"
            :href="
              'https://www.google.com/maps/dir/?api=1&destination=' +
                location.position.lat +
                ',' +
                location.position.lng
            "
            target="_blank"
            >Route planen</ion-button
          >
        </div>
      </GMapInfoWindow>
    </GMapMarker>
  </GMapMap>
</template>

<script>
import { useDoctor } from "@/composables/useDoctor";
import { IonButton } from "@ionic/vue";
import { Browser } from "@capacitor/browser";

export default {
  props: {
    locations: {
      type: Array,
      required: true,
    },
    center: {
      type: Object,
      required: true,
    },
  },
  components: {
    IonButton,
  },
  data() {
    return {
      openedMarkerID: null,
    };
  },
  methods: {
    openMarker(id) {
      this.openedMarkerID = id;
    },
  },
  setup() {
    const { addDoctor } = useDoctor();
    const book = async (location) => {
      await addDoctor(location);
      Browser.open({
        url: "https://dr-flex.de/embed?medicalPracticeId=" + location.id,
      });
    };

    return { book };
  },
};
</script>

<style></style>
